module.exports = __webpack_public_path__ + "img/service3EN.ef0c8415.svg";